import React from 'react';

const UserDemographicsIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="11" cy="13" r="4" fill="#BA68C8"/>
        <path d="M4 25c0-4.4 3.1-7 7-7s7 2.6 7 7" fill="#BA68C8"/>
        <circle cx="21" cy="13" r="4" fill="#FFB74D"/>
        <path d="M14 25c0-4.4 3.1-7 7-7s7 2.6 7 7" fill="#FFB74D"/>
        <circle cx="11" cy="13" r="4" fill="url(#demographicsShineA)"/>
        <path d="M4 25c0-4.4 3.1-7 7-7s7 2.6 7 7" fill="url(#demographicsShineA)"/>
        <circle cx="21" cy="13" r="4" fill="url(#demographicsShineB)"/>
        <path d="M14 25c0-4.4 3.1-7 7-7s7 2.6 7 7" fill="url(#demographicsShineB)"/>
        <circle cx="27" cy="7" r="1.3" fill="#F5C518"/>
        <circle cx="5" cy="8" r="0.9" fill="#66BB6A" opacity="0.7"/>
        <defs>
            <radialGradient id="demographicsShineA" cx="35%" cy="25%" r="80%">
                <stop offset="0" stopColor="#fff" stopOpacity="0.4"/>
                <stop offset="0.5" stopColor="#fff" stopOpacity="0.05"/>
                <stop offset="1" stopColor="#000" stopOpacity="0.08"/>
            </radialGradient>
            <radialGradient id="demographicsShineB" cx="35%" cy="25%" r="80%">
                <stop offset="0" stopColor="#fff" stopOpacity="0.4"/>
                <stop offset="0.5" stopColor="#fff" stopOpacity="0.05"/>
                <stop offset="1" stopColor="#000" stopOpacity="0.08"/>
            </radialGradient>
        </defs>
    </svg>
);

export default UserDemographicsIcon;